import React from "react";
import DashboardShell from "../components/DashboardShell";

function RiderDashboard() {
  const links = [
    { to: "/rider", label: "Overview" },
    { to: "/rider/orders", label: "Assigned Orders" },
  ];

  return (
    <DashboardShell title="Rider — Jummy's Global" subtitle="View and manage your deliveries." links={links}>
      <h1>Overview</h1>
      <p>As a rider, you will see orders assigned to you, update their status, and track completed deliveries.</p>
    </DashboardShell>
  );
}

export default RiderDashboard;
